import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-subscribe",
  "use": "svg-icon-subscribe-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"svg-icon-subscribe\"><defs><style>#svg-icon-subscribe .cls-1{fill:#717b7f}</style></defs><path class=\"cls-1\" d=\"M6.04 5.04a1 1 0 000 2 8.93 8.93 0 018.92 8.92 1 1 0 102 0A10.932 10.932 0 006.04 5.04z\" /><path class=\"cls-1\" d=\"M6.04 9.308a1 1 0 000 2 4.657 4.657 0 014.652 4.652 1 1 0 102 0A6.66 6.66 0 006.04 9.308z\" /><circle class=\"cls-1\" cx=\"6.638\" cy=\"15.208\" r=\"1.413\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol